import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
} from 'reactstrap';

function AgeCheckbox(props) {
  const {
    type = 'checkbox', name, checked = false, onChange,
  } = props;

  return (
    <>
      <Input
        name={name}
        type={type}
        checked={checked}
        onChange={onChange}
      />
    </>
  );
}

AgeCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default AgeCheckbox;
